Object.defineProperty(exports, '__esModule', { value: true });

var BACKGROUND = [
    'accent',
    'info',
    'attention-muted',
    'positive-muted',
    'negative-muted',
    'primary',
    'primary-inverted',
    'secondary',
    'secondary-inverted',
    'tertiary',
    'tertiary-inverted',
    'quaternary',
    'quaternary-inverted',
    'specialbg-component',
    'specialbg-component-inverted',
    'specialbg-primary-grouped',
    'specialbg-secondary-grouped',
    'specialbg-tertiary-grouped',
    'specialbg-secondary-transparent',
    'specialbg-secondary-transparent-inverted',
    'specialbg-tertiary-transparent',
    'specialbg-tertiary-transparent-inverted',
];
var BORDER_COLOR = [
    'accent',
    'key',
    'key-inverted',
    'link',
    'primary',
    'primary-inverted',
    'secondary',
    'secondary-inverted',
    'tertiary',
    'tertiary-inverted',
    'underline',
    'underline-inverted',
    'graphic-attention',
    'graphic-link',
    'graphic-negative',
    'graphic-positive',
    'specialbg-secondary-transparent',
    'specialbg-secondary-transparent-inverted',
    'specialbg-tertiary-transparent',
    'specialbg-tertiary-transparent-inverted',
];
var SHADOW = [
    'shadow-xs',
    'shadow-s',
    'shadow-m',
    'shadow-l',
    'shadow-xl',
    'shadow-xs-hard',
    'shadow-s-hard',
    'shadow-m-hard',
    'shadow-l-hard',
    'shadow-xl-hard',
    'shadow-xs-up',
    'shadow-s-up',
    'shadow-m-up',
    'shadow-l-up',
    'shadow-xl-up',
    'shadow-xs-hard-up',
    'shadow-s-hard-up',
    'shadow-m-hard-up',
    'shadow-l-hard-up',
    'shadow-xl-hard-up',
];

exports.BACKGROUND = BACKGROUND;
exports.BORDER_COLOR = BORDER_COLOR;
exports.SHADOW = SHADOW;
